import {
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { isEqual } from 'lodash';
import {
  CommonFlowsSelectionComponent,
  DSCP_FLOWS_TYPE
} from '../common-flows-selection.component';
import { DSCP_FLOWS, MOS_CONFIG } from './models/model';

const DEFAULT_FLOWS = {
  name: 'Flow',
  frameSize: 512,
  txInterval: 100,
  padding: 425,
  paddingMin: 0,
  paddingMax: 8913,
  frameSizeMin: 87,
  frameSizeMax: 9000,
  dfBit: true,
  reflectorUDP: 50000
};
@Component({
  selector: 'nrwl-common-flow-list',
  templateUrl: './common-flow-list.component.html',
  styleUrls: ['./common-flow-list.component.scss']
})
export class CommonFlowListComponent implements OnInit, OnChanges {
  @ViewChild('currentForm', { static: true }) form: NgForm;
  // eslint-disable-next-line
  @Output() sendFlowList = new EventEmitter<any>();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  //eslint-disable-next-line
  @Input() dataSource: any;
  @Input() mosCodecValue: any;
  @Input() vlanId: any = 0;
  @Input() ipAddressType = 'ipv4';
  @Input() displayedColumns: any = null;
  @Input() availableFlowNames = [];
  @Input() txInterval: any = [];
  @Input() dfBitDisabled? = false;
  @Input() selectedDeviceIndex = 0;
  flowDataSource: MatTableDataSource<DSCP_FLOWS_TYPE>;
  displayedFlowsColumns = ['dscp', 'padding', 'frame-size', 'TxInterval', 'dfBit', 'add'];
  flows = [];
  TxIntervalDropdown = [];
  codecValue: string;
  flowIndex = 1;
  constructor(public dialog: MatDialog) {
    this.flowDataSource = new MatTableDataSource<DSCP_FLOWS_TYPE>([]);
  }
  ngOnInit(): void {
    this.displayedFlowsColumns = this.displayedColumns;
    this.TxIntervalDropdown = this.txInterval;
    this.updateDatasource();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSource && changes.dataSource.currentValue) {
      this.updateDatasource();
    }
    if (
      changes.mosCodecValue &&
      changes.mosCodecValue.currentValue !== changes.mosCodecValue.previousValue
    ) {
      this.onCodecChange(changes.mosCodecValue.currentValue);
    }

    if (
      (changes.ipAddressType &&
        changes.ipAddressType.currentValue !== changes.ipAddressType.previousValue) ||
      (changes.vlanId && changes.vlanId.currentValue !== changes.vlanId.previousValue)
    ) {
      this.onCodecChange(this.mosCodecValue);
    }
  }

  updateDatasource(): void {
    const tableData = this.dataSource.map(item => {
      return {
        name: item.name,
        id: item.dscp,
        value: this.getFlowName(item.dscp),
        txInterval: item.txInterval,
        frameSize: item.header || 87 + item.padding,
        padding: item.padding,
        checked: true,
        dfBit: item.dfBit,
        reflectorUDP: item.reflectorUDP
      };
    });
    this.flowDataSource.data = tableData;
    this.flowIndex = this.flowDataSource.data.length;
    this.setSelectedFlows();
    this.checkNameAlreadyExists();
    this.emitFlows();
  }

  txIntervalUpdated(name: string, element: DSCP_FLOWS_TYPE): void {
    this.flows.filter(item => {
      if (item.dscp === element.id) {
        item.txInterval = this.form.controls[name]?.value;
      }
    });
    this.emitFlows();
  }
  frameSizeUpdated(name: string, element: DSCP_FLOWS_TYPE): void {
    this.form.controls[name].setValidators([
      Validators.required,
      Validators.min(DEFAULT_FLOWS.frameSizeMin),
      Validators.max(DEFAULT_FLOWS.frameSizeMax)
    ]);
    this.form.controls[name].updateValueAndValidity();
    const index = name.substring(9);
    this.flows.filter(item => {
      if (item.dscp === element.id) {
        item.frameSize = this.form.controls[name].value;
        item.header = this.form.controls[name].value;
        item.padding = item.frameSize - DEFAULT_FLOWS.frameSizeMin;
        this.form.controls['padding' + index].setValue(item.padding);
        if (this.form.controls[name].value > DEFAULT_FLOWS.frameSizeMax) {
          this.form.controls['padding' + index].setValue(DEFAULT_FLOWS.paddingMax);
          this.form.controls[name].setValue(DEFAULT_FLOWS.frameSizeMax);
          item.padding = DEFAULT_FLOWS.paddingMax;
          item.frameSize = DEFAULT_FLOWS.frameSizeMax;
          item.header = this.form.controls[name].value;
        } else if (this.form.controls[name].value < DEFAULT_FLOWS.frameSizeMin) {
          this.form.controls['padding' + index].setValue(DEFAULT_FLOWS.paddingMin);
          item.padding = DEFAULT_FLOWS.paddingMin;
        }
      }
    });
    this.emitFlows();
  }

  nameUpdated(name: string, element: DSCP_FLOWS_TYPE): void {
    this.flows.filter(item => {
      if (item.dscp === element.id) {
        item.name = this.form.controls[name]?.value;
      }
    });
    this.checkNameAlreadyExists();
    this.emitFlows();
  }

  reflectorUdpUpdated(name: string, element: DSCP_FLOWS_TYPE): void {
    this.flows.filter(item => {
      if (item.dscp === element.id) {
        item.reflectorUDP = this.form.controls[name]?.value;
      }
    });
    this.emitFlows();
  }

  paddingUpdated(name: string, element: DSCP_FLOWS_TYPE): void {
    this.form.controls[name].setValidators([
      Validators.required,
      Validators.min(DEFAULT_FLOWS.paddingMin),
      Validators.max(DEFAULT_FLOWS.paddingMax)
    ]);
    this.form.controls[name].updateValueAndValidity();
    const index = name.substring(7);
    this.flows.filter(item => {
      if (item.dscp === element.id) {
        item.padding = this.form.controls[name].value;
        item.frameSize = item.padding + DEFAULT_FLOWS.frameSizeMin;
        item.header = item.padding + DEFAULT_FLOWS.frameSizeMin;
        this.form.controls['frameSize' + index].setValue(item.frameSize);
        if (this.form.controls[name].value > DEFAULT_FLOWS.paddingMax) {
          this.form.controls[name].setValue(DEFAULT_FLOWS.paddingMax);
          this.form.controls['frameSize' + index].setValue(DEFAULT_FLOWS.frameSizeMax);
          item.padding = DEFAULT_FLOWS.paddingMax;
          item.frameSize = DEFAULT_FLOWS.frameSizeMax;
          item.header = DEFAULT_FLOWS.frameSizeMax;
        } else if (this.form.controls[name].value < DEFAULT_FLOWS.paddingMin) {
          this.form.controls[name].setValue(DEFAULT_FLOWS.paddingMin);
          this.form.controls['frameSize' + index].setValue(DEFAULT_FLOWS.frameSizeMin);
          item.padding = DEFAULT_FLOWS.paddingMin;
          item.frameSize = DEFAULT_FLOWS.frameSizeMin;
          item.header = DEFAULT_FLOWS.frameSizeMax;
        }
      }
    });
    this.emitFlows();
  }

  onCodecChange(codec: string): void {
    this.flows.forEach(item => {
      const defaultCodecFlowValue = this.defaultFlowsByCodec(codec, item);
      if (!(codec === MOS_CONFIG.NONE || codec === MOS_CONFIG.GENERIC)) {
        item.header = defaultCodecFlowValue.frameSize;
        item.padding = defaultCodecFlowValue.padding;
        item.txInterval = defaultCodecFlowValue.txInterval;
      } else {
        item.header = DEFAULT_FLOWS.frameSize;
        item.padding = DEFAULT_FLOWS.padding;
        item.txInterval = DEFAULT_FLOWS.txInterval;
      }
    });
    this.emitFlows();
    this.setTableData();
  }

  setTableData(): void {
    const filterData = this.flows.map(item => {
      return {
        name: item.name,
        id: item.dscp,
        txInterval: item.txInterval,
        frameSize: item.header || 87 + item.padding,
        padding: item.padding,
        checked: true,
        value: this.getFlowName(item.dscp),
        dfBit: item.dfBit,
        reflectorUDP: item.reflectorUDP
      };
    });
    this.flowDataSource.data = filterData;
  }
  getFlowName(id: number): string {
    const flowname = DSCP_FLOWS.find(item => item.id === id);
    if (flowname) {
      return flowname.value;
    }
  }

  disableSetMosConfig(flow: DSCP_FLOWS_TYPE): boolean {
    const currentFlowConfig = {
      frameSize: flow.frameSize,
      padding: flow.padding,
      txInterval: flow.txInterval,
      dfBit: true
    };
    if (isEqual(currentFlowConfig, this.defaultFlowsByCodec(this.mosCodecValue, flow))) {
      return true;
    }
    return false;
  }

  defaultFlowsByCodec(codec: string, flow: DSCP_FLOWS_TYPE): DSCP_FLOWS_TYPE {
    const vlan = this.getVlan() ? 4 : 0;
    const ipVlaue = this.ipAddressType === 'ipv6' ? 74 : 54;
    const frameSize = this.frameSizeDefaultSumValue(codec) + ipVlaue + vlan;
    return {
      frameSize: frameSize,
      padding: frameSize - 87,
      txInterval: this.getTxInterValBasedOnMOSValue(codec),
      dfBit: true
    };
  }
  getVlan(): number {
    if (this.vlanId && this.vlanId > 0) {
      return this.vlanId;
    }
    return null;
  }
  frameSizeDefaultSumValue(codec: string): number {
    switch (codec) {
      case 'G.711_64_kbps': {
        return 160;
      }
      case 'G.723.1_5.3_kbps': {
        return 66;
      }
      case 'G.726_24_kbps': {
        return 60;
      }
      case 'G.729_8_kbps': {
        return 100;
      }
    }
  }
  getTxInterValBasedOnMOSValue(codec: string): number {
    switch (codec) {
      case 'G.711_64_kbps':
      case 'G.726_24_kbps': {
        return 20;
      }
      case 'G.723.1_5.3_kbps':
      case 'G.729_8_kbps': {
        return 100;
      }
    }
  }

  setConfigBasedOnCodec(flow: DSCP_FLOWS_TYPE): void {
    const defaultCodecFlowValue = this.defaultFlowsByCodec(this.mosCodecValue, flow);
    flow.frameSize = defaultCodecFlowValue.frameSize;
    flow.padding = defaultCodecFlowValue.padding;
    flow.txInterval = defaultCodecFlowValue.txInterval;
    this.setSelectedFlows();
    this.setTableData();
  }

  dfBitValUpdate(name: string, element: DSCP_FLOWS_TYPE): void {
    this.flows.filter(item => {
      if (item.dscp === element.id) {
        item.dfBit = this.form.controls[name]?.value;
      }
    });
    this.emitFlows();
  }

  //eslint-disable-next-line
  checkNameAlreadyExists(): any {
    this.flowDataSource.data.forEach(data => {
      data.nameExist =
        this.flows.some(item => item.name === data.name && item.dscp !== data.id) ||
        this.availableFlowNames.includes(data.name);
    });
  }

  openDscpFlowsDialog(): void {
    DSCP_FLOWS.forEach(item => {
      item['checked'] = false;
    });
    const filteredFlows = DSCP_FLOWS.filter(
      element => !this.flowDataSource.data.some(item => element.value === item.value)
    );
    const dialogRef = this.dialog.open(CommonFlowsSelectionComponent, {
      width: '350px',
      disableClose: true,
      data: filteredFlows
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.length) {
        result.forEach(item => {
          this.flowIndex++;
          if (
            !(this.mosCodecValue === MOS_CONFIG.NONE || this.mosCodecValue === MOS_CONFIG.GENERIC)
          ) {
            const defaultCodecFlowValue = this.defaultFlowsByCodec(this.mosCodecValue, item);
            item.name = `${DEFAULT_FLOWS.name} ${this.selectedDeviceIndex + 1}-${this.flowIndex}`;
            item.frameSize = defaultCodecFlowValue.frameSize;
            item.txInterval = defaultCodecFlowValue.txInterval;
            item.padding = defaultCodecFlowValue.padding;
            item.dfBit = defaultCodecFlowValue.dfBit;
            item.reflectorUDP = DEFAULT_FLOWS.reflectorUDP;
            this.flowDataSource.data.push(item);
          } else {
            item.name = `${DEFAULT_FLOWS.name} ${this.selectedDeviceIndex + 1}-${this.flowIndex}`;
            item.frameSize = DEFAULT_FLOWS.frameSize;
            item.txInterval = DEFAULT_FLOWS.txInterval;
            item.padding = DEFAULT_FLOWS.padding;
            item.dfBit = DEFAULT_FLOWS.dfBit;
            item.reflectorUDP = DEFAULT_FLOWS.reflectorUDP;
            this.flowDataSource.data.push(item);
          }
        });
        const filterData = this.flowDataSource.filteredData;
        this.flowDataSource.data = filterData;
        this.checkNameAlreadyExists();
        this.setSelectedFlows();
      }
    });
  }
  setSelectedFlows(): void {
    this.flows = this.flowDataSource.data.map(item => {
      return {
        name: item.name,
        dscp: item.id,
        txInterval: item.txInterval,
        frameSize: item.frameSize,
        padding: item.padding,
        dfBit: item.dfBit,
        reflectorUDP: item.reflectorUDP
      };
    });
    this.emitFlows();
  }

  removeDscpFlows(index: number): void {
    this.flowDataSource.data.splice(index, 1);
    const filterData = this.flowDataSource.filteredData;
    this.flowDataSource.data = filterData;
    this.setSelectedFlows();
  }

  emitFlows(): void {
    this.sendFlowList.emit({
      flows: this.flows,
      isValidForm: this.form.valid && !this.flowDataSource.data.some(item => item.nameExist)
    });
  }
}
